export const INFO_TERKINI_NAVIGATION_ORIGIN_KEY =
  'info-terkini-navigation-origin'

const ROUTE_EVENT_TRIGGER_MAPPING = {
  '/': 'HOMEPAGE',
  '/home': 'HOMEPAGE',
  '/akun': 'ACCOUNT',
  '/info-terkini': 'INFORMATION_PAGE',
}

export const DEFAULT_INFORMATION_PAGE_EVENT_TRIGGER = 'INFORMATION_PAGE'

export const getInformationPageEventTrigger = (route?: string): string => {
  return (
    ROUTE_EVENT_TRIGGER_MAPPING?.[route] ??
    DEFAULT_INFORMATION_PAGE_EVENT_TRIGGER
  )
}

export const setInformationPageNavigationOrigin = (route?: string): void => {
  if (typeof window === 'undefined') return

  window.sessionStorage.setItem(
    INFO_TERKINI_NAVIGATION_ORIGIN_KEY,
    getInformationPageEventTrigger(route)
  )
}

export const consumeInformationPageNavigationOrigin = (): string => {
  if (typeof window === 'undefined') {
    return DEFAULT_INFORMATION_PAGE_EVENT_TRIGGER
  }

  const eventTrigger =
    window.sessionStorage.getItem(INFO_TERKINI_NAVIGATION_ORIGIN_KEY) ??
    DEFAULT_INFORMATION_PAGE_EVENT_TRIGGER

  window.sessionStorage.removeItem(INFO_TERKINI_NAVIGATION_ORIGIN_KEY)

  return eventTrigger
}
